import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
let MarkCard = class MarkCard extends Vue {
    // highlight:string = highlight;
    status = 'ONLINE';
    name = '';
    showName = false;
    markUrl = require('@blade-sxp/screen/assets/old-online.png');
    siteIcon = require('@blade-sxp/screen/assets/site.svg');
    url = '';
    zoneId;
    vertices;
    handleClick(e) {
        e.stopPropagation();
        this.$emit('markClick', { zoneId: this.zoneId, vertices: this.vertices });
    }
    onMouseEnter() {
        this.$emit('onMouseEnter', { zoneId: this.zoneId, vertices: this.vertices });
    }
    onMouseLeave() {
        this.$emit('onMouseLeave', { zoneId: this.zoneId, vertices: this.vertices });
    }
};
MarkCard = __decorate([
    Component({
        name: 'markCard',
    })
], MarkCard);
export default MarkCard;
